// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";


// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";

import moment from "moment";
import { getPricingTemplates, getPricingGroups } from "network/service";
import { useNavigate } from "react-router-dom";

import * as XLSX from 'xlsx';
import TableData from "./data";
import AddEditTemplatePopup from "./components/AddTemplatePopup/AddTemplatePopup";
import { Autocomplete } from "@mui/material";
import MDInput from "components/MDInput";
import { useLoading } from "context/loading.context";
import { getCountries, fetchModes } from "network/service";
import AddEditPriceGroupPopup from "./components/PriceGroupPopup";
import AddEditPriceListPopup from "./components/PriceListPopup";
import { getPriceList } from "network/service";
import AddEditPriceModePopup from "./components/PriceModePopup";


export default function PricingLists() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [groups, setGroups] = useState([]);
    const [countries, setCountries] = useState([]);
    const [modes, setModes] = useState([]);
    const [selTempl, setSelTempl] = useState([]);
    const [selgrp, setSelGrp] = useState([]);
    const [selCnt, setSelCnt] = useState([]);
    const [selMode, setSelMode] = useState([]);
    const { formTemplateRows, templateHeaders } = TableData();
    const [templatepopup, setTemplatePopp] = useState({ visible: false, details: null });
    const [groupPopup, setGroupPopup] = useState({ visible: false, details: null });
    const [pricelistPopup, setPriceListPopup] = useState({ visible: false, details: null });
    const [pricemodePopup, setPriceModePopup] = useState({ visible: false, details: null });
    const { showLoader, hideLoader } = useLoading();
    const [vals, setVals] = useState([]);

    const fetchPricingTemplates = async () => {
        getPricingTemplates().then((resp) => {
            setTemplates(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }

    const fetchPricingGroups = async () => {
        getPricingGroups().then((resp) => {
            setGroups(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }

    const fetchCountries = async () => {
        getCountries().then((resp) => {
            setCountries(resp.data);
        }).catch((err) => {
            console.log(err);
        });
    }

    const fetchPriceModes = async () => {
        fetchModes().then((resp) => {
            setModes(resp.data);
        }).catch((err) => {
            console.log(err);
        });
    }



    useEffect(() => {
        fetchPricingTemplates();
    }, [setTemplates]);

    useEffect(() => {
        fetchCountries();
    }, [setCountries]);

    useEffect(() => {
        fetchPricingGroups();
    }, [setGroups]);

    useEffect(() => {
        fetchPriceModes();
    }, [setModes]);

    const fetchPricingsall = () => {
        if (selCnt && selTempl && selgrp && selMode) {
            showLoader();
            getPriceList(`pricing_template=${selTempl._id}&pricing_group=${selgrp._id}&country=${selCnt._id}&pricing_mode=${selMode._id}`).then((resp) => {
                if (resp.data.length > 0) {
                    setVals(resp.data[0].rate);
                }
                else {
                    setVals([]);
                }
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                hideLoader();
            });
        }
        else {
            setVals([]);
        }
    }


    useEffect(() => {
        fetchPricingsall();
    }, [selCnt, selTempl, selgrp, selMode]);


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}><Grid container spacing={6}>
                {
                    templatepopup.visible && <AddEditTemplatePopup
                        isopen={templatepopup.visible}
                        handleclose={() => {
                            setTemplatePopp({ visible: false, details: null });
                        }}
                        handlesuccess={() => {
                            setTemplatePopp({ visible: false, details: null });
                            fetchPricingTemplates();
                        }} />
                }
                {
                    groupPopup.visible && <AddEditPriceGroupPopup
                        isopen={groupPopup.visible}
                        handleclose={() => {
                            setGroupPopup({ visible: false, details: null });
                        }}
                        handlesuccess={() => {
                            setGroupPopup({ visible: false, details: null });
                            fetchPricingGroups();
                        }} />
                }
                {
                    pricemodePopup.visible && <AddEditPriceModePopup
                        isopen={pricemodePopup.visible}
                        handleclose={() => {
                            setPriceModePopup({ visible: false, details: null });
                        }}
                        handlesuccess={() => {
                            setPriceModePopup({ visible: false, details: null });
                            fetchPriceModes();
                        }} />
                }
                {
                    pricelistPopup.visible && <AddEditPriceListPopup
                        isopen={pricelistPopup.visible}
                        setSelCnt={setSelCnt}
                        countries={countries}
                        setSelGrp={setSelGrp}
                        groups={groups}
                        setSelTempl={setSelTempl}
                        modes={modes}
                        selMode={selMode}
                        setSelMode={setSelMode}
                        templates={templates}
                        selCnt={selCnt}
                        selgrp={selgrp}
                        selTempl={selTempl}
                        handleclose={() => {
                            setPriceListPopup({ visible: false, details: null });
                        }}
                        handlesuccess={() => {
                            setPriceListPopup({ visible: false, details: null });
                            fetchPricingsall();
                        }} />
                }
                <Grid item xs={12}>
                    <Card>
                        <MDBox
                            mx={2}
                            mt={-3}
                            py={3}
                            px={2}
                            variant="gradient"
                            bgColor="info"
                            borderRadius="lg"
                            coloredShadow="info"
                        >
                            <MDTypography variant="h6" color="white">
                                Templates
                            </MDTypography>
                        </MDBox>
                        <Grid
                            container xs={12}
                            direction='row'
                            width={"100%"}
                            className="form-wrapper"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: "space-around", margin: 10 }}
                        >
                            <Grid item xs={5} xl={2} className="form-content">
                                <Autocomplete
                                    disableClearable
                                    style={{ flex: "7", margin: 0 }}
                                    label="Template"
                                    options={templates}
                                    getOptionLabel={(option) => option.template_name || ''}
                                    renderInput={(params) => <MDInput {...params} label="Template" />}
                                    onChange={(event, newValue) => {
                                        setSelTempl(newValue);
                                    }}
                                    value={selTempl}
                                />
                            </Grid>
                            <Grid item xs={5} xl={2} className="form-content">
                                <Grid container flexDirection={"row"} alignItems="center" justifyContent="space-between">
                                    <Autocomplete
                                        disableClearable
                                        style={{ flex: "7", margin: 0 }}
                                        label="Group"
                                        options={groups}
                                        getOptionLabel={(option) => option.name || ''}
                                        renderInput={(params) => <MDInput {...params} label="Group" />}
                                        onChange={(event, newValue) => {
                                            setSelGrp(newValue);
                                        }}
                                        value={selgrp}
                                    />
                                    <MDButton variant="gradient" color="info" style={{ margin: 5 }} iconOnly
                                        onClick={async () => {
                                            setGroupPopup({ visible: true, details: null });
                                        }}>
                                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                                    </MDButton>
                                </Grid>
                            </Grid>
                            <Grid item xs={5} xl={2} className="form-content">
                                <Autocomplete
                                    style={{ flex: "7", margin: 0 }}
                                    label="Country"
                                    options={countries}
                                    getOptionLabel={(option) => option.name || ''}
                                    renderInput={(params) => <MDInput {...params} label="Country" />}
                                    onChange={(event, newValue) => {
                                        setSelCnt(newValue);
                                    }}
                                    value={selCnt}
                                />
                            </Grid>
                            <Grid item xs={5} xl={2} className="form-content">
                                <Grid container flexDirection={"row"} alignItems="center" justifyContent="space-between">
                                    <Autocomplete
                                        style={{ flex: "7", margin: 0 }}
                                        label="Mode"
                                        options={modes}
                                        getOptionLabel={(option) => option.name || ''}
                                        renderInput={(params) => <MDInput {...params} label="Mode" />}
                                        onChange={(event, newValue) => {
                                            setSelMode(newValue);
                                        }}
                                        value={selMode}
                                    />
                                    <MDButton variant="gradient" color="info" style={{ margin: 5 }} iconOnly
                                        onClick={async () => {
                                            setPriceModePopup({ visible: true, details: null });
                                        }}>
                                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                                    </MDButton>
                                </Grid>
                            </Grid>
                            <MDButton variant="gradient" color="info" style={{ margin: 5 }}
                                onClick={async () => {
                                    setPriceListPopup({ visible: true, details: null });
                                }}>
                                <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                                &nbsp;Add
                            </MDButton>
                        </Grid>

                        {/* </MDBox> */}
                        <MDBox pt={0}>
                            <DataTable
                                table={{ columns: templateHeaders, rows: formTemplateRows(vals, selTempl) }}
                                canSearch
                            />
                        </MDBox>
                    </Card>
                </Grid>
            </Grid>
            </MDBox>
        </DashboardLayout>
    );
}